import {fetchUtils} from 'react-admin';

export const httpClient = (url, options = {}) => {
    const token = localStorage.getItem('token');

    if (!options.headers) {
        options.headers = new Headers({
            Accept: 'application/ld+json'
        });
    }

    if (token) {
        options.headers.set('Authorization', `Bearer ${token}`);
    }

    return fetchUtils.fetchJson(url, options).catch(error => {
        // Saga-driven calls bypass react-admin's AUTH_ERROR, so an expired token used to
        // fail silently and leave wizard dropdowns empty until a manual re-login.
        if (401 === error.status) {
            localStorage.removeItem('token');
            window.location.reload();
        }
        throw error;
    });
};
